module.exports = __webpack_public_path__ + "static/media/settings_icon.fd41d68e.png";